import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIButton from 'UIComponents/button/UIButton';
import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { ANALYZE_OPT_IN } from '../../../constants/Events';
import { trackClickAnalyzeOptIn, trackViewAnalyzeTab } from '../../../utils/usageTracker';
import { getHasSuperAdminScope, getIsUngatedToForecastingMultipleOutcomes } from '../../../selectors/authSelectors';
import AnalyzeOptInModal from './AnalyzeOptInModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AnalyzeOptIn = () => {
  const hasSuperAdminScope = useSelector(getHasSuperAdminScope);
  const isFmoEnabled = useSelector(getIsUngatedToForecastingMultipleOutcomes);
  const [isModalOpen, setIsModalOpen] = useState(false);
  useEffect(() => {
    trackViewAnalyzeTab({
      subscreen: ANALYZE_OPT_IN
    });
  }, []);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "space-around",
    blockSize: "600px",
    children: [/*#__PURE__*/_jsx(EmptyState, {
      primaryContent: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: isFmoEnabled ? 'analyze.optIn.bodyWithFmo' : 'analyze.optIn.body'
        }), /*#__PURE__*/_jsx(UITooltip, {
          disabled: !!hasSuperAdminScope,
          placement: "bottom",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "analyze.optIn.nonAdminTooltip"
          }),
          children: /*#__PURE__*/_jsx(View, {
            display: "inline-block",
            marginBlockStart: "400",
            children: /*#__PURE__*/_jsx(UIButton, {
              "data-test-id": "analyze-open-opt-in-modal-button",
              disabled: !hasSuperAdminScope,
              onClick: () => {
                trackClickAnalyzeOptIn();
                setIsModalOpen(true);
              },
              use: "tertiary",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "analyze.optIn.optInCTA"
              })
            })
          })
        })]
      }),
      secondaryContent: /*#__PURE__*/_jsx(Illustration, {
        name: "forecasting-ai",
        width: 150
      }),
      secondaryContentWidth: 200,
      titleText: /*#__PURE__*/_jsx(Text, {
        as: "h4",
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "analyze.optIn.title"
        })
      }),
      reverseOrder: true
    }), isModalOpen && /*#__PURE__*/_jsx(AnalyzeOptInModal, {
      onClickClose: () => setIsModalOpen(false)
    })]
  });
};
export default AnalyzeOptIn;